import { Container } from '@mui/material';
import CircularProgressIcon from '@mui/material/CircularProgress';

const ContainerSpinner = () => (
  <Container
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}
  >
    <CircularProgressIcon
      sx={{ width: '100px !important', height: '100px !important', mb: '33%' }}
    />
  </Container>
);

export default ContainerSpinner;
